gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);


window.lenis = new Lenis();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);


window.addEventListener('DOMContentLoaded', ()=>{

  const $header = document.querySelector('#header');
  const $sectionKV = document.querySelectorAll('.section-kv')[0];
  ScrollTrigger.create({
    trigger: '#main',
    start: 'top top',
    end: 'bottom top',
    onUpdate: self => {
      const scrollTop = self.scroll();
      const dir = self.direction;
      const threshold = $sectionKV ? Math.min(window.innerHeight / 2, $sectionKV.offsetHeight - $header.offsetHeight) : window.innerHeight / 2;
      $header.classList.toggle('--hide', dir === 1 && scrollTop > threshold);
      $header.classList.toggle('--opaque', scrollTop > 40);
    }
  })

  document.querySelectorAll('[data-hide-header="true"]').forEach( $el => {
    ScrollTrigger.create({
      trigger: $el,
      start: () => `top ${$header.offsetHeight}`,
      end: 'bottom top',
      onEnter: () => {
        $header.classList.remove('--nav-open');
        $header.querySelector('.toggle-nav').classList.remove('is-active');
        $header.style.setProperty('--header-offset-top', `0px`);
      },
      onLeaveBack: () => {
        $header.classList.remove('--nav-open');
        $header.querySelector('.toggle-nav').classList.remove('is-active');
        $header.style.setProperty('--header-offset-top', `0px`);
      },
      onEnterBack: self => {
        $header.classList.remove('--nav-open');
        $header.querySelector('.toggle-nav').classList.remove('is-active');
        $header.style.setProperty('--header-offset-top', `0px`);
      },
      onUpdate: self => {
        const offsetTop = $el.getBoundingClientRect().top - $header.offsetHeight;
        $header.style.setProperty('--header-offset-top', `${Math.min(0,offsetTop)}px`);
      }
    });
  });

  $header.querySelector('.toggle-nav').addEventListener('click', () => {
    $header.querySelector('.toggle-nav').classList.toggle('is-active');
    document.body.classList.toggle('--nav-open', $header.querySelector('.toggle-nav').classList.contains('is-active'));
    if (window.lenis) {
      if (document.body.classList.contains('--nav-open')) {
        window.lenis.stop();
      } else {
        window.lenis.start();
      }
    }
  })

  $header.querySelectorAll('.menu-item-has-children').forEach($el => {
    const toggleBtn = $el.querySelectorAll('a')[0];
    toggleBtn.addEventListener('click', (e ) => {
      e.preventDefault();
      $el.classList.toggle('--active');
    });
    if ($el.classList.contains('current-menu-parent')) {
      $el.classList.add('--active');
    }
  })
})


const skipIntro = window.location.hash && window.location.hash === '#skip_intro' ? true : false;
if (skipIntro) {
  document.querySelector('body').classList.remove('loading');
  document.getElementById('intro').remove();
} else {
  window.addEventListener('DOMContentLoaded', function () {
    const $intro = document.getElementById('intro');
    if ( $intro ) {
      const $cursor = document.getElementById('cursor');

      const onMouseMove = () => {
        if ($cursor) $cursor.setAttribute('data-status', 'intro');
      }
      $intro.addEventListener('mousemove', onMouseMove);
      $intro.addEventListener('click', () => {
        $intro.removeEventListener('mousemove', onMouseMove);
        document.querySelector('body').classList.remove('loading');
        if ($cursor) $cursor.removeAttribute('data-status');
        window.dispatchEvent(new Event('INTRO_END'));
        gsap.to($intro, {
          autoAlpha: 0, duration: .4, ease: Linear.easeNone, onComplete: () => {
            $intro.remove();
          }
        });
        // gsap.to($intro.querySelector('video'), {scale:3, duration: 1.5, ease: Quint.easeOut});
      })
    } else {
      document.querySelector('body').classList.remove('loading');
    }
  });
}